import React from 'react';

import { Container, Row, Col } from 'react-bootstrap';
import { easeOut, motion } from 'framer-motion';
import './MySkills.css'




const data = [


    {
        style: "textHeadOne",
        name: "User-Research",
        description: "I understand the needs, behaviors, and preferences of the target users",
        duration:0.3

    },
    {
        style: "textHeadTwo",
        name: "User-Empathy",
        description: "I gain deep insights into users' perspectives and emotions to drive empathetic design decisions.",
        duration:0.6
    },
    {
        style: "textHeadThree",
        name: "Agile Methodology",
        description: "I embrace a collaborative, iterative approach for flexible and continuous improvement.",
        duration:0.9
    },

    {
        style: "textHeadFour",
        name: "Wireframing",
        description: "I create skeletal interface layouts to visualize functionality and structure.",
        duration:0.3
    },
    {
        style: "textHeadFive",
        name: "Prototyping",
        description: "I design interactive models to test and refine design concepts.",
        duration:0.6
    },
    {
        style: "textHeadSix",
        name: "Testing",
        description: " I Conduct evaluations to identify and address usability issues for an enhanced user experience.",
        duration:0.9
    },
]


const Cards = (props) => {
    return (

        <Col xs={12} md={6} lg={4} >
            <motion.div initial={{ opacity: 0, }} whileInView={{ opacity: 1, }} transition={{ duration:props.data.duration, delay: 0.5, timingFunction: easeOut }} viewport={{ once: true }} >
                <div className="myRolex" style={{ marginBottom: 1.8 + 'rem' }} >
                    <div className="textHead" id={props.data.style} >
                        <h4 className="skillsHeading">{props.data.name}</h4>
                    </div>

                    <p style={{ color: 'white', fontSize: 0.8 + 'rem', lineHeight: 199 + '%', wordSpacing: 0.1 + 'rem', fontFamily: 'Jost, sans-serif' }} >
                        {props.data.description}
                    </p>

                    
                </div>
            </motion.div>
        </Col>

    )
}

function MySkills(props) {


    return (
        <Container fluid className="MySkills" >
            <Row style={{ marginTop: 2 + 'rem' }}>

                <Col xs={12} md={3} lg={3}>
                    <motion.div initial={{ opacity: 0, }} whileInView={{ opacity: 1, }} transition={{ duration: 0.5, delay: 0.3, timingFunction: easeOut }} >
                        <h2 className="aboutHeading_designprocess">Design Process</h2>
                        <p style={{fontSize:0.81+"rem"}} className="headingText">I have ability to work effectivelly on the following skills below and this will be very cool</p>
                    </motion.div>
                </Col>

                <Col xs={12} md={9} lg={9}>
                    <Row style={{ paddingTop: 1 + 'rem' }}>
                        {
                            data.map((item, index) => {
                                return (
                                    <Cards key={index} data={item} />

                                )
                            })
                        }
                    </Row>
                </Col>

            </Row>



           

        </Container>
    );
}

export default MySkills;


